import { useSubjectSelector } from '@procom-labs/common'

import { authStore } from '@auth-portal/store'

export const useIsUserCreationAllowed = (): boolean => {
  const { authConfigOptions } = useSubjectSelector(authStore, [
    'authConfigOptions',
  ])

  if (authConfigOptions) return authConfigOptions?.isUserCreationAllowed
  return false
}
